import { ICollection } from '@/interfaces/doccen-lib/collection.interface';
import { ILastestSubscriptionPlanResponse } from '@/interfaces/subscription.interface';
import { PropsWithChildren, createContext } from 'react';

export interface ICollectionDetailContext {
  collection: ICollection | undefined;
  latestSubscription: ILastestSubscriptionPlanResponse | undefined;
}

export const CollectionDetailContext = createContext<ICollectionDetailContext>({
  collection: undefined,
  latestSubscription: undefined,
});

const CollectionDetailProvider = ({
  children,
  ...value
}: PropsWithChildren<ICollectionDetailContext>) => {
  return (
    <CollectionDetailContext.Provider value={value}>
      {children}
    </CollectionDetailContext.Provider>
  );
};

export default CollectionDetailProvider;
